export default __webpack_public_path__ + "static/media/copy-icon.36929213.svg";